import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PageForAdUnitTransferListDTO } from '../types/pageForAdUnitTransferListDTO'

export const PAGE_FOR_AD_UNIT_TRANSFER_LIST_FRAGMENT: TypedDocumentNode<PageForAdUnitTransferListDTO> = gql`
  fragment PageForAdUnitTransferList on Page {
    id
    name
  }
`
